export const COMPANY_SUBSCRIPTION_ACCESS_REQUEST = 'COMPANY_SUBSCRIPTION_ACCESS_REQUEST';
export const COMPANY_SUBSCRIPTION_ACCESS_SUCCESS = 'COMPANY_SUBSCRIPTION_ACCESS_SUCCESS';
export const COMPANY_SUBSCRIPTION_ACCESS_FAILURE = 'COMPANY_SUBSCRIPTION_ACCESS_FAILURE';

export const COMPANY_SUBSCRIPTION_ACCESS_CLEAR = 'COMPANY_SUBSCRIPTION_ACCESS_CLEAR';
